<template>
    <a rel="nofollow" href="https://www.ccbillcomplaintform.com/ccbill/form/CCBillContentRemovalRequest1/formperma/sBK2jfIoZWAFw2hRRt5Rv2PQncscFzpvOH6bPcwopas">{{ $t('components.cc_bill.complaints') }}</a>
</template>

<script>
export default {
    name: "CCBillComplaintFormLink",
}
</script>
